import VueCookies from "vue-cookies";
import Vue from "vue";

// default options config: { expires: '1d', path: '/', domain: '', secure: '', sameSite: 'Lax' }
Vue.use(VueCookies, { expire: "7d" });
